<style>
        .tbl-lead-info-left tr td:nth-child(1) {
            font-weight: bold;
            width: 125px;
        }
        
        .tbl-lead-info-right tr td:nth-child(1) {
            font-weight: bold;
            width: 125px;
        }
    </style>
    <div class="modal-primary" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Pending Account Management</h4>
                <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="card">
                    <div class="card-body">
                        <!-- <h5 class="card-title">Lead Activity</h5> -->
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Business Name</th>
                                    <th>Contact Name</th>
                                    <th>Phone</th>
                                    <th>RSE Name</th>
                                    <th>Days</th>
                                    <th>Created At</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let assignNotication of assignNoticationDetais; let i = index">
                                <tr>                                    
                                    <td>{{assignNotication.business.name}}</td>
                                    <td>{{assignNotication.business.ownerName}}</td>
                                    <td>{{assignNotication.business.phoneNumber}}</td>
                                    <td>{{assignNotication.name}}</td>
                                    <td>{{assignNotication.days}}</td>
                                    <td>{{assignNotication.created_at | dateFormat }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Close</button>
            </div>
        </div>



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/assignment-notifi-detail.html